// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { ProcedureEditorInterface_abstract } from './../abstract/SagaActionLib/ProcedureEditorInterface_abstract';
export class ProcedureEditorInterface extends ProcedureEditorInterface_abstract {}
